import { cx, styled } from "simplydo/react/styled";

import type { CardContentProps } from "./Card.types";

const Content = styled.div`
  flex-grow: 1;
  padding: 1em;

  &.is-secondary {
    background: #f9fafb;
  }
`;

const CardContentComponent = (props: CardContentProps) => {
  const { secondary, children, className, style } = props;
  return (
    <Content
      className={cx(secondary && "is-secondary", className)}
      style={style}
    >
      {children}
    </Content>
  );
};

export const CardContent = styled(CardContentComponent)``;
